import type { ReactNode } from "react";
import { TopBar } from "./TopBar";
import { AppSidebar } from "./AppSidebar";
import { CommandPalette } from "@/components/command-palette";

const placeholderActions = [
  { id: "go-quotes", label: "Go to quotes", group: "Navigate", perform: () => { window.location.href = "/quotes"; } },
  { id: "go-jobs",   label: "Go to jobs",   group: "Navigate", perform: () => { window.location.href = "/jobs"; } },
] as const;

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full overflow-hidden">
      <a href="#main" className="sr-only focus-visible:not-sr-only">Skip to main content</a>
      <AppSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main id="main" className="flex-1 overflow-auto bg-background">
          {children}
        </main>
      </div>
      <CommandPalette actions={placeholderActions} />
    </div>
  );
}
